import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter } from 'react-router';
import { QueryParamProvider } from 'use-query-params';
import Container from './components/container/container';
import OrganizationSearchContext from './context/organization_search.context';
import CustomReactRouter7Adapter from '../utilities/custom_react_router_7_adapter';

const OrganizationSearch = ({isDesktop, organizationTypes, isRecruiter, displayNewLogo}) => {
  return (
    <BrowserRouter>
      <QueryParamProvider adapter={CustomReactRouter7Adapter}>
        <OrganizationSearchContext.Provider value={{isDesktop, organizationTypes, isRecruiter}}>
          <Container displayNewLogo={displayNewLogo} />
        </OrganizationSearchContext.Provider>
      </QueryParamProvider>
    </BrowserRouter>
  );
};

OrganizationSearch.propTypes = {
  displayNewLogo: PropTypes.bool.isRequired,
  isDesktop: PropTypes.bool.isRequired,
  organizationTypes: PropTypes.array.isRequired,
  isRecruiter: PropTypes.bool.isRequired,
};

export default OrganizationSearch;
